var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 4H20.75V6H18.75V19C18.75 19.5523 18.3023 20 17.75 20H3.75C3.19772 20 2.75 19.5523 2.75 19V6H0.75V4H5.75V1C5.75 0.44772 6.19772 0 6.75 0H14.75C15.3023 0 15.75 0.44772 15.75 1V4ZM16.75 6H4.75V18H16.75V6ZM7.75 9H9.75V15H7.75V9ZM11.75 9H13.75V15H11.75V9ZM7.75 2V4H13.75V2H7.75Z",
    fill: "#B3B3B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.d73639e6c301eb97dd6b2c292952104e.svg";
export { ForwardRef as ReactComponent };